import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="text-center">
                <h1 className="display-1 fw-bold mb-3">404</h1>
                <p className="fs-3 mb-3">
                    <span className="text-danger">Opps!</span> Page not found.
                </p>
                <p className="lead mb-3">찾으시는 페이지가 존재하지 않습니다.</p>
                <Link to="/" className="btn btn-primary">
                    홈으로 이동
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
